<div class="card">
    <div class="card-body">
        <table  class="table table-bordered table-hover toggle-circle " >
            <thead>
                <tr>
                    <th>#</th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Titulo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Grupo<span class="footable-sort-indicator"></span></th>
                    <th data-toggle="true" class="footable-visible footable-first-column footable-sortable footable-sorted">Escala<span class="footable-sort-indicator"></span></th>
                    <th class="min-width footable-visible footable-last-column text-center">Ver/Editar</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let question of questions; index as i">
                    <td>{{i+1}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.title}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.group}}</td>
                    <td class="footable-visible footable-first-column"><span class="footable-toggle"></span>{{question.scale}}</td>
                    <td class="footable-visible footable-last-column text-center">
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleEdit(question)"><i class="fa fa-pencil" aria-hidden="true"></i></button>
                        <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="handleDelete(question._id, i)" ><i class="fa fa-eraser" ></i></button>
                    </td>
                </tr>
            </tbody>
        </table>

        
    </div>
</div>

<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Chaside</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="chasideForm" (ngSubmit)="register()">
                    <div class="form-body">
                        <div class="row p-t-20">
                            <div class="col-md-6">
                                <div  >
                                    <label class="control-label">Grupo</label>
                                    <select formControlName="group" class="form-control custom-select">
                                        <option value="Intereses">Intereses</option>
                                        <option value="Aptitudes">Aptitudes</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                            </div>
                            <div class="col-md-6">    
                                <label class="control-label">Escala</label>
                                <select formControlName="scale" class="form-control custom-select">
                                    <option value="C">C</option>
                                    <option value="H">H</option>
                                    <option value="A">A</option>
                                    <option value="S">S</option>
                                    <option value="I">I</option>
                                    <option value="D">D</option>
                                    <option value="E">E</option>
                                </select>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label class="control-label">Índice</label>
                                    <input formControlName="index" type="text"  class="form-control" placeholder="Índice">
                                </div>
                            </div>
                        </div>             
                    </div>
                    <div class="form-actions m-t-20">
                        <button *ngIf="isEditing" type="button" class="btn btn-warning btn-rounded waves-effect m-r-20" (click)="isEditing = false">Cancelar</button>
                        <button type="submit" class="btn btn-success btn-rounded waves-effect m-r-20">{{isEditing?'Actualizar':'Guardar'}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
